/**
 * Verification documents as they were sent.
 *
 * An image is shown whole, at its own proportions — never cropped to a
 * thumbnail box, since the detail an admin is checking (a number, a stamp, a
 * name) is as likely to be at the edge as in the middle. Clicking opens the
 * full-size file. Anything else (a PDF) is a link with its name.
 *
 * Links are signed and expire, so a page left open goes stale; reloading it
 * fetches fresh ones.
 */
export function DocumentPreviews({ documents = [] }) {
  const docs = (documents || []).filter((doc) => doc && typeof doc === 'object');
  if (!docs.length) return null;

  return (
    <div className="doc-previews">
      {docs.map((doc, index) => {
        const name = doc.fileName || `Document ${index + 1}`;
        if (!doc.url) {
          return (
            <span key={doc._id || index} className="doc-previews__file muted">
              {name}
            </span>
          );
        }
        if (doc.mimeType?.startsWith('image/')) {
          return (
            <a key={doc._id || index} className="doc-previews__image" href={doc.url} target="_blank" rel="noreferrer" title={`Open ${name} full size`}>
              <img src={doc.url} alt={name} loading="lazy" />
              <span className="doc-previews__name">{name}</span>
            </a>
          );
        }
        return (
          <a key={doc._id || index} className="doc-previews__file" href={doc.url} target="_blank" rel="noreferrer">
            {name}
          </a>
        );
      })}
    </div>
  );
}

export default DocumentPreviews;
